/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Downloaden via de App Store",
      "Echte ontmoetingen met groepen in de buurt",
      "Chat met je nieuwe crew via Hives.",
      "Vind mensen die bij jou passen",
      "Wat je passie ook is, er is een Hive voor jou!",
      "Een veilige plek om jezelf te zijn",
      "Kies uit verborgen en zichtbare Hives.",
      "Aan de slag",
      "Wat je passie ook is, er is een Hive voor jou!",
      "Leer een nieuwe groep mensen kennen in Hives op Bumble BFF",
      "Uitnodiging voor Hives",
      "Maak kennis met groepen mensen bij jou in de buurt via Hives, de nieuwe functie van Bumble BFF. Maak vandaag jouw BFF-profiel aan in de Bumble-app.",
      "Downloaden via Google Play",
      "Cookies beheren",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dagen"
            ],
            "singular": [
                  "dag"
            ]
      },
      "hour": {
            "plural": [
                  "uur"
            ],
            "singular": [
                  "uur"
            ]
      },
      "minute": {
            "plural": [
                  "minuten"
            ],
            "singular": [
                  "minuut"
            ]
      },
      "month": {
            "plural": [
                  "maanden"
            ],
            "singular": [
                  "maand"
            ]
      },
      "second": {
            "plural": [
                  "seconden"
            ],
            "singular": [
                  "seconde"
            ]
      },
      "year": {
            "plural": [
                  "jaar"
            ],
            "singular": [
                  "jaar"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
